<template>
  <div>
    <es-table
      :data="basicData"
      :span-method="objectSpanMethod"
      :row-class-name="tableRowClassName"
      height="284"
      @cell-mouse-enter="handleMouseEnter"
      @cell-mouse-leave="handleMouseLeave"
    >
      <template slot="empty"
        ><es-empty
          style="margin: 25px; color: #999; line-height: 40px"
          :description="$t(`暂无更多数据`)"
          image="data:image/png;base64,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"
        ></es-empty>
      </template>
      <es-table-column prop="tagName" :label="$t(`类别`)" v-if="showCheckBox"></es-table-column>
      <es-table-column :label="$t(`服务名称`)" width="200">
        <template slot-scope="scope">
          <es-checkbox
            v-model="scope.row.checked"
            :disabled="[2, 4].includes(scope.row.type)"
            :label="scope.row"
            @change="changeCheckList(scope.row)"
            :checked="scope.row.type === 2"
            v-if="showCheckBox"
          >
            &nbsp;
          </es-checkbox>
          <span class="name">{{ scope.row.name }}</span>
        </template>
      </es-table-column>
      <es-table-column :label="$t(`服务状态`)">
        <template slot-scope="scope">
          <span class="status">
            {{ scope.row.type === 4 ? $t('价格审核中') : scope.row.type === 2 ? $t('已开通') : $t('未开通') }}
          </span>
        </template>
      </es-table-column>
      <es-table-column :label="$t(`价格（元/次）`)">
        <template slot-scope="scope">
          <span class="price">{{ scope.row.price }}</span>
          <es-tag type="info" v-if="[1, 4].includes(scope.row.type)">{{ $t('标准价') }}</es-tag>
        </template>
      </es-table-column>
    </es-table>
  </div>
</template>
<script>
export default {
  props: {
    tableData: {
      type: Array,
    },
    showCheckBox: {
      type: Boolean,
      default: false,
    },
    hoverProp: {
      // 用来判断hover的属性
      type: String,
      default: '',
    },
  },
  data() {
    return {
      cellName: '',
      basicData: this.tableData,
    }
  },
  watch: {
    tableData(newVal) {
      this.basicData = this.setTableRowspan(newVal)
    },
  },
  methods: {
    setTableRowspan(dataArray, tag = this.hoverProp) {
      if (!this.showCheckBox) {
        return dataArray
      }
      if (dataArray.length === 0) {
        return
      }
      // 不展示价格是0的子产品 不展示标签是充值子项允许0元计费

      const modifiedA = dataArray
        .filter(item => item.price !== 0)
        .map(item => {
          /* i18n-ignore */
          if (item.tagName === '充值子项允许0元计费') {
            item.tagName = '其他'
          }

          return item
        })
      // 把modifiedA按tagName分类
      const groupedA = modifiedA.reduce((acc, item) => {
        if (!acc[item.tagName]) {
          acc[item.tagName] = []
        }
        if (!acc[item.tagName].find(node => node.name === item.name)) {
          acc[item.tagName].push(item)
        }

        return acc
      }, {})
      // 分类后的每个元素中的第一项添加属性rowspan,并将rowspan的值设置为每个元素的个数,最后扁平化

      const rowspanA = Object.entries(groupedA)
        .map(([tagName, items]) => {
          const rowspan = items.length
          const firstItem = { ...items[0], rowspan }

          return [firstItem, ...items.slice(1)]
        })
        .flat()

      return rowspanA
    },
    handleMouseEnter(row, column, cell, event) {
      this.cellName = row[this.hoverProp]
    },
    handleMouseLeave(row, column, cell, event) {
      this.cellName = ''
    },
    tableRowClassName({ row, rowIndex }) {
      let typeClass = ''
      let hoverClass = ''
      if (row.type === 2) {
        typeClass = 'color_52C41A'
      }
      if (row.type === 3) {
        typeClass = 'color_07B35D'
      }
      if (row.type === 4) {
        typeClass = 'color_FF7216'
      }
      if (row.type === 1) {
        typeClass = 'color_666'
      }
      if (this.hoverProp && this.cellName === row[this.hoverProp]) {
        hoverClass = 'hover-class'
      }

      return `${typeClass} ${hoverClass}`
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (this.showCheckBox && columnIndex === 0) {
        if (row.rowspan) {
          return {
            rowspan: row.rowspan,
            colspan: 1,
          }
        }

        return {
          rowspan: 0,
          colspan: 0,
        }
      }
    },
    changeCheckList({ id, checked }) {
      const checkList = this.basicData.filter(item => {
        if (item.id === id) {
          item.checked = checked
        }

        return item.type !== 2 && item.checked
      })
      this.$emit('changeCheckList', JSON.parse(JSON.stringify(checkList)))
    },
  },
  created() {
    this.setTableRowspan(this.basicData)
  },
}
</script>
<style lang="less" scoped>
.price {
  display: inline-block;
  width: 30px;
}
.color_07B35D span.name {
  color: #07b35d;
}
.color_FF7216 span.status {
  color: #ff7216;
}
.color_52C41A span.status {
  color: #52c41a;
}
.color_666 span {
  color: #666;
}
/deep/tbody .es-table_1_column_2 {
  border-left: 1px solid #e4e4e4;
}
/deep/.has-gutter .es-table th,
.has-gutter .es-table tr {
  background-color: rgb(246, 246, 246) !important;
  color: #333333;
}
/deep/ .es-table--enable-row-hover .hover-class > td {
  background: #f5f7fa !important;
}
/deep/ .es-empty__image {
  width: 64px;
}
</style>
